import React from 'react'
import hash from 'object-hash'
import { RegisterUserCollaboratorView, ContractView } from '../../views'
import { ClientService, Auth0Service, LocalStorageService, UserService, AddressService, DownloadSignaturesService, ContractService, MessageService } from '../../../services'
import { ValidateInputPure, UserInvitedInformationPure, MessagePure } from '../../pures'
import { RegisterCollaboratorValidator } from '../../../validators'
import ChangePasswordAction from '../change-password/change-password.action'
import { PersonalInformation, PhoneValidation, TermsCondition } from '../../../assets/logos/icons'
import { useTranslation } from "react-i18next"
import { formatPhoneNumber } from 'react-phone-number-input'

class RegisterUserCollaboratorAction extends React.Component {
    constructor(props) {
        super(props)
    }
    input = React.createRef()

    state = {
        userId: '',
        clientId: '',
        userTypeId: '',
        languageId: '',
        email: '',
        showLoadingRequesting: false,
        showCompletedRequesting: false,
        showErrorRequesting: false,
        redirectToChangePass: false,
        donwloadSingaturesScreen: false,
        isDownloadSignaturesData: false,
        termnsAndConditions: false,
        contractBullets: [],
        loading: true,
        planChecked: false,
        donwloadLoading: false,
        eventId: '',
        step: 0,
        userUpdated: null,
        selectedStep: 0,
        collaboratorSteps: [
            { icon: PersonalInformation, itemElement: this.props.t('register.user.collaborator.action.personalDataTitle'), itemSup: 'register.user.collaborator.action.nextLabel', key: 'register.personalData', labelreturn: 'register.user.collaborator.action.close', label: 'register.user.collaborator.action.personalData' },
            // { icon: PhoneValidation, itemElement: this.props.t('registration.action.validation'), itemSup: this.props.t('registration.action.Steps.nextLaber'), key: 'register.address', labelreturn: this.props.t('registration.action.Steps.backLaber'), label: this.props.t('messagePure.validation') },
            { icon: TermsCondition, itemElement: this.props.t('register.user.collaborator.action.tos'), itemSup: 'register.user.collaborator.action.nextLabel', key: 'register.user.collaborator.action.tos', labelreturn: 'register.user.collaborator.action.backLabel', itemMoral: 'register.user.collaborator.action.nextLabel', label: 'register.user.collaborator.action.tos' },
        ],
        isLastStep: false,
        logo: null,
        validationCode: '',
        validationCodeCorrect: false,
        focused: false,
        cellphoneNumber: '',
        flags: [
            {
                language: 'es',
                src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_MX}`,
                label: 'ES',
                status: true
            },
            {
                label: '|',
                status: false
            },
            {
                language: 'en',
                src: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_LANGUAGE_US}`,
                label: 'EN',
                status: false
            }
        ]
    }
    collaboratorStepMetadata = [
        { number: 0, component: UserInvitedInformationPure },
        // { number: 1, component: MessagePure },
        { number: 2, component: ContractView, action: 'validateContract' },
    ]
    token = {}
    user = {}
    url = process.env.REACT_APP_MIFIRMA_API
    localStorageService = new LocalStorageService()
    auth0Service = new Auth0Service()
    userService = new UserService(this.url)
    addressService = new AddressService(this.url)
    downloadSignaturesService = new DownloadSignaturesService(this.url)
    contractService = new ContractService(this.url)
    clientService = new ClientService(this.url)
    messageService = new MessageService(this.url)
    isCollaborator = true

    validator = RegisterCollaboratorValidator(this.props.t)

    async componentDidMount() {
        this.token = this.localStorageService.getLocalStorageItem('token').idToken
        this.user = this.localStorageService.getLocalStorageItem('user')

        let contractBullets = await this.contractService.getContractBullets(this.token)

        let userInformation = this.user.userMetaData.userA3Cloud
        let userInformationAkubicaFirmaDigital = this.user.userMetaData.userMifirma

        await this.localStorageService.setLocalStorageItem('clientLogo', '')
        let logo = await this.fetchClientImage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')

        let languageId = userInformationAkubicaFirmaDigital.language.isokey
        let language = this.localStorageService.getLocalStorageItem("preferredLanguage")
        if (language) languageId = language
        this.setFlags(language)

        return this.setState({
            userId: userInformation.id,
            userTypeId: userInformationAkubicaFirmaDigital.userType.id,
            languageId,
            clientId: userInformation.clientId,
            email: userInformation.email,
            contractBullets,
            loading: false,
            logo
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.termnsAndConditions !== this.state.termnsAndConditions) {
            if (this.state.termnsAndConditions) {
                let eventId = hash({ hash: Math.random().toString(36).substring(7) })
                this.setState({ eventId })
            }
        }
    }

    /**
     * @author Martín Sánchez
     * @description Check if the contract is selected
     */
    validateContract = async () => {
        if (!this.state.termnsAndConditions) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.collaborator.action.messagePleaseTos'))
            return false
        } else if (this.state.userTypeId === Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) && !this.state.planChecked) {
            await this.toggleErrorRequesting(true, this.props.t('register.user.collaborator.action.messageConfirm'))
            return false
        } else {
            return true
        }
    }


    changeStepNumber = (step) => {
        let stepLenght = this.state.collaboratorSteps.length - 1
        step = (step >= stepLenght) ? stepLenght : step + 1
        return step
    }

    onBackStep = async (event) => {
        event.preventDefault()
        let stepNumber = this.stepBack(this.state.selectedStep)
        this.setState({ selectedStep: stepNumber })
    }
    stepBack = (step) => {
        if (this.state.loading && step === 0) {
            this.setState({ selectedPersonType: false })
        } else if (step === 0) {
            this.setState({ selectedPersonType: false })
            this.handleButtonLogOut()
        } else {
            step = step - 1
        }
        return step
    }
    handleButtonLogOut = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
        this.auth0Service.logout()
    }


    /**
    * @author Alan Aguilar
    * @description Method to show the loading dialog modal
    * @date 15-12-2020
    * @memberof RegisterUserCollaboratorAction
    */
    toggleLoadingRequesting = (value) => {
        this.setState({
            showLoadingRequesting: value,
        })
    }

    /**
* @author Alan Aguilar
* @description Method to show the WARNING dialog modal
* @memberof SignatureRequestAction
*/
    toggleWarningRequesting = (value, message) => {
        this.setState({
            showWarningRequesting: value,
            message: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showWarningRequesting: false,
                    })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the complete request dialog modal
    * @date 15-12-2020
    * @memberof RegisterUserCollaboratorAction
    */
    toggleCompletedRequesting = (value, message) => {
        this.setState({
            showCompletedRequesting: value,
            messageComplete: message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showCompletedRequesting: false
                    })
                }, 4000)
            }
        )
    }

    /**
    * @author Alan Aguilar
    * @description Method to show the Error request dialog modal
    * @date 15-12-2020
    * @memberof RegisterUserCollaboratorAction
    */
    toggleErrorRequesting = (value, message) => {
        this.setState({
            showErrorRequesting: value,
            message, message
        },
            () => {
                setTimeout(() => {
                    this.setState({
                        showErrorRequesting: false,
                    })
                }, 4000)
            })
    }
    async fetchClientImage() {
        let result = await this.clientService.getClientImage(this.token)
        return result?.data?.image
    }
    onAcceptTermnsAndConditions = () => this.setState({ termnsAndConditions: !this.state.termnsAndConditions })
    onAcceptPlan = () => this.setState({ planChecked: !this.state.planChecked })

    /**
     * @author Martín Sánchez
     * @description Close the modal after some time
     */
    onCloseOpenModal = () => this.setState({ showNotification: !this.state.showNotification })

    openModalTermsCond = (value) => {
        this.setState({
            modalTermsCond: value
        });
    }

    openModalPolicityPrivacy = (value) => {
        this.setState({
            modalPolicityPrivacy: value
        });
    }

    handleMessage = () => {
        setTimeout(() => {
            this.onCloseOpenModal()
        }, 15000);
    }

    onCellphoneChange = (cellphone) => {
        if (cellphone) {
            this.setState({
                cellphoneNumber: cellphone
            })
        }
    }

    /**
    * @author Alan Aguilar
    * @description Method to clear the localStorage and close the sesion
    * @date 15-12-2020
    * @memberof RegisterUserCollaboratorAction
    */
    onCloseSesion = async () => {
        let logo = await this.localStorageService.getLocalStorageItem('clientLogo')
        await this.localStorageService.clearLocalStorage()
        await this.localStorageService.setLocalStorageItem('clientLogo', logo ? logo : '')
        this.auth0Service.logout()
    }

    /**
    * @author Alan Aguilar
    * @description Hanlde method submit to make the petition in Mifirma-api
    * @date 15-12-2020
    * @memberof RegisterUserCollaboratorAction
    */
    onSubmitRegisterUserCollaborator = async (dataItem) => {
        let selectedStep = this.state.selectedStep
        let stepNumber = this.changeStepNumber(selectedStep)
        let action = this.collaboratorStepMetadata[selectedStep].action
        let result = true
        if (action) { // Only when the submit step requires an action the result is evaluated
            result = await this[action](dataItem)
            this.handleMessage()
        }

        if (result) { // When result its ok, we can flow to next steps
            // if ((selectedStep === 0)) {
            //     let phoneNumber = dataItem.cellphoneNumber || this.state.cellphoneNumber
            //     let newPhoneNumber = phoneNumber.replace("+", "");
            //     let message = await this.messageService.sendMessage(
            //         newPhoneNumber,
            //         false,
            //         this.user.userToken.name,
            //         this.token
            //     );

            //     if (message.statusCode !== 200) {
            //         await this.toggleWarningRequesting(true, message.message);
            //         return false;
            //     }
            // }
            // if ((selectedStep === 1)) {
            //     if (this.state.validationCode.length !== 6) {
            //         this.toggleWarningRequesting(true,
            //             'El código no cumple con la cantidad de carácteres necesarios.')
            //         return
            //     }
            //     let validationCode = this.state.validationCode
            //     let codeValidator = await this.messageService.validateMessage(
            //         validationCode,
            //         this.user.userToken.name,
            //         this.token
            //     );

            //     if (codeValidator.data) {
            //         this.setState({
            //             validationCodeCorrect: true
            //         })
            //     } else {
            //         await this.toggleWarningRequesting(true, 'Teléfono o mensaje Incorrectos.')
            //         return false
            //     }
            // }

            if (selectedStep === 1 && result) { // If we are in the last step then we save the data

                try {
                    await this.toggleLoadingRequesting(true)
                    let {
                        firstName,
                        secondLastName,
                        street,
                        externalNumber,
                        zipCode,
                        state,
                        firstLastName,
                        phoneNumber,
                        colony,
                        internalNumber,
                        township,
                        country,
                        rfc
                    } = dataItem

                    let {
                        clientId,
                        userTypeId,
                        languageId,
                        email,
                        eventId,
                        termnsAndConditions,
                        cellphoneNumber
                    } = this.state


                    // Validate opcional data
                    cellphoneNumber = (cellphoneNumber === undefined || cellphoneNumber === '') ? ' ' : cellphoneNumber
                    phoneNumber = (phoneNumber === undefined || phoneNumber === '') ? ' ' : phoneNumber

                    let newCellPhoneNumber = formatPhoneNumber(cellphoneNumber)
                    let newPhoneNumber = formatPhoneNumber(phoneNumber)

                    street = (street === undefined || street === '') ? ' ' : street
                    externalNumber = (externalNumber === undefined || externalNumber === '') ? ' ' : externalNumber
                    internalNumber = (internalNumber === undefined || internalNumber === '') ? ' ' : internalNumber
                    rfc = (rfc === undefined || rfc === '') ? ' ' : rfc
                    zipCode = (zipCode === undefined || zipCode === '') ? '00000' : zipCode
                    colony = (colony === undefined || colony === '') ? ' ' : colony
                    township = (township === undefined || township === '') ? ' ' : township
                    state = (state === undefined || state === '') ? ' ' : state
                    country = (country === undefined || country === '') ? ' ' : country

                    this.token = this.localStorageService.getLocalStorageItem('token').idToken

                    // Create a new address with the data provided by the user
                    let addressUpdate = await this.addressService.createAddressInvited(street, internalNumber, externalNumber, colony, township, state, country, zipCode, email, this.token)
                    if (!(Number(addressUpdate.statusCode) === 200)) throw new Error('No se puedo completar la peticion')

                    //Update the user information and the addressId
                    let addressId = addressUpdate.data.address.data.id
                    let userData = {
                        eventId,
                        firstName,
                        clientId,
                        addressId,
                        firstLastName,
                        secondLastName,
                        phoneNumber: newPhoneNumber,
                        cellphoneNumber: newCellPhoneNumber,
                        countryCodePhone: phoneNumber,
                        countryCodeCellphone: cellphoneNumber,
                        userTypeId,
                        languageId,
                        rfc,
                        termnsAndConditions,
                        accountId: process.env.ACCOUNT_ID
                    }
                    let userUpdated = await this.userService.updateUser(userData, this.token)
                    this.setState({ userUpdated, isLastStep: true })

                    if (!(Number(userUpdated.statusCode) === 200)) throw new Error('No se puedo completar la peticion')

                    await this.toggleLoadingRequesting(false)
                    await this.toggleCompletedRequesting(true)
                    this.setState({ redirectToChangePass: true })
                } catch (error) {
                    await this.toggleLoadingRequesting(false)
                    await this.toggleErrorRequesting(true)
                    return false
                }
            }
            this.setState({ selectedStep: stepNumber })
        }
    }

    /**
     * @author Gustavo Pacheco
     * @description check if signatures donwload 
     */
    checkDowloadSignatures = () => this.setState({ isDownloadSignaturesData: true })


    onReSendMessage = async (event, validationType) => {
        event.preventDefault();
        let phoneNumber = this.state.cellphoneNumber;
        let newPhoneNumber = phoneNumber.replace("+", "");
        let message = this.messageService.reSendMessage(newPhoneNumber, validationType, this.user.userToken.name, this.token);

        if (validationType === 'phoneNumber') {
            await this.toggleCompletedRequesting(true, this.props.t("registration.action.resendMessageSMS"));
        } else if (validationType === 'mail') {
            await this.toggleCompletedRequesting(true, this.props.t("registration.action.resendMessageEmail"));
        }

        return message;
    };

    //Button Validate input
    handleClick = () => {
        this.input.current.focus()
    }

    handleFocus = () => {
        this.setState({ focused: true })
    }

    handleBlur = () => {
        this.setState({
            focused: false,
        })
    }

    handleChange = (e) => {
        const validationCode = e.target.value
        const CODE_LENGTH = new Array(6).fill(0)

        this.setState((state) => {
            if (state.validationCode.length >= CODE_LENGTH.length) return null
            return {
                validationCode: (state.validationCode + validationCode).slice(0, CODE_LENGTH.length),
            }
        })
    }

    handleKeyUp = (e) => {
        if (e.key === "Backspace") {
            this.setState((state) => {
                return {
                    validationCode: state.validationCode.slice(0, state.validationCode.length - 1),
                }
            })
        }
    }

    setFlags = (language) => {
        if (!language) return
        let flags = this.state.flags.map((flag) => {
            flag.status = (language === flag.language) ? true : false
            return flag
        })

        this.setState({
            flags
        })
    }

    render() {
        if (this.state.redirectToChangePass === false) {

            return (
                <RegisterUserCollaboratorView
                    {...this.state}
                    setFlags={this.setFlags}
                    isCollaborator={this.isCollaborator}
                    validator={this.validator}
                    isLastStep={this.state.isLastStep}
                    validateInput={ValidateInputPure}
                    onSubmitRegisterUserCollaborator={this.onSubmitRegisterUserCollaborator}
                    onCloseSesion={this.onCloseSesion}
                    toggleLoadingRequesting={this.toggleLoadingRequesting}
                    toggleCompletedRequesting={this.toggleCompletedRequesting}
                    toggleErrorRequesting={this.toggleErrorRequesting}
                    toggleWarningRequesting={this.toggleWarningRequesting}
                    onAcceptTermnsAndConditions={this.onAcceptTermnsAndConditions}
                    stepMetadata={this.collaboratorStepMetadata}
                    steps={this.state.collaboratorSteps}
                    onChangeStep={this.onChangeStep}
                    onBackStep={this.onBackStep}
                    onAcceptPlan={this.onAcceptPlan}
                    openModalTermsCond={this.openModalTermsCond}
                    openModalPolicityPrivacy={this.openModalPolicityPrivacy}
                    donwloadLoading={this.donwloadLoading}

                    onReSendMessage={this.onReSendMessage}
                    handleClick={this.handleClick}
                    handleFocus={this.handleFocus}
                    handleBlur={this.handleBlur}
                    handleChange={this.handleChange}
                    handleKeyUp={this.handleKeyUp}

                    onCellphoneChange={this.onCellphoneChange}

                    input={this.input}
                    goToApp={async () => {
                        await this.toggleCompletedRequesting(true)
                        this.setState({ redirectToChangePass: true })
                    }}
                />
            )
        } else {
            return (<ChangePasswordAction
                {...this.state}
            />)
        }
    }
}


function RegisterUserCollaboratorActionContainer(props) {
    const { t } = useTranslation()
    return (
        <RegisterUserCollaboratorAction {...props} t={t} />
    )
}


export { RegisterUserCollaboratorActionContainer as default }